import axios from 'axios';

export function advertiserSignupVerifyCode(email, code) {
    return axios.post(`${process.env.REACT_APP_API_URL}/advertiser/signup/verify-code`, { email, code });
}
